import { Message } from "../message.model";

export interface BodyDailyEntries {
  Tipo_consulta_BD: "RANGO_DIAS";
  fecha_inicial: string;
  fecha_final: string;
  sector: string;
  sucursal: string;
  fecha_periodo_anterior?: {
    fecha_inicial: string;
    fecha_final: string;
  };
}

export interface ResponseDailyEntries {
  column_name: ColumnNameDailyEntries | Message;
}

export interface ColumnNameDailyEntries {
  "public data": DataDailyEntries;
}

export interface DataDailyEntries {
  anio_base:     number;
  anio_anterior: number;
  fechas:        DateDailyEntries[];
  resumen:       SummaryDailyEntries;
}

export interface DateDailyEntries {
  Dia:                       string;
  Entradas:                  number;
  Entradas_periodo_anterior: number;
  Salidas?:                   number;
}

export interface SummaryDailyEntries {
  total_visitantes:          number;
  total_visitantes_anterior: number;
  diferencia:                number;
  porcentaje:                string;
  indicador:                 string;
}
